<template>
  <el-tooltip
    ref="tooltip"
    :effect="effect"
    :placement="placement"
    :open-delay="openDelay"
    :popper-class="computedClass"
    v-bind="$attrs"
  >
    <slot />
  </el-tooltip>
</template>

<script>
import ElTooltip from 'vue-xpc/src/element-ui/packages/tooltip';
import xpcConfig from 'vue-xpc/src/config';
export default {
  name: 'RtTooltip',
  components: { ElTooltip },
  props: {
    // 自定义背景色
    backgroundColor: {
      type: String
      // default: 'black'
    },
    effect: {
      type: String,
      default: 'dark'
    },
    placement: String,
    // 自定义透明度
    opacity: {
      type: Number,
      default: 0.7
    },
    // 44070 【Tooltip】默认延时速率改为300ms
    // 延迟出现，单位毫秒
    openDelay: {
      type: Number,
      default: 300
    },
    size: String,
    // 最大宽度
    maxWidth: {
      type: Number,
      default: null
    },
    popperClass: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      // 把对应的样式传给空div做渲染
      // tooltipClass: []
    }
  },

  computed: {
    innerBackgroundColor () {
      if (this.backgroundColor) {
        return this.backgroundColor;
      }
      return this.effect === 'light' ? 'white' : 'black';
    },
    computedClass () {
      let classList = '';
      // this.tooltipClass = []
      if (this.innerBackgroundColor) {
        classList += `rt-xpc-tooltip-none-border`;
        if (this.placement.includes('top')) {
          classList += ` rt-xpc-tooltip-top-is-${this.innerBackgroundColor}`;
        }
        if (this.placement.includes('left')) {
          classList += ` rt-xpc-tooltip-left-is-${this.innerBackgroundColor}`;
        }
        if (this.placement.includes('right')) {
          classList += ` rt-xpc-tooltip-right-is-${this.innerBackgroundColor}`;
        }
        if (this.placement.includes('bottom')) {
          classList += ` rt-xpc-tooltip-bottom-is-${this.innerBackgroundColor}`;
        }
      }
      let opacity = this.opacity || xpcConfig.get('toolTip.opacity');
      switch (opacity) {
        case 0.9:
          classList += ` rt-xpc-tooltip-opacity-nine`;
          break;
        case 0.7:
          classList += ` rt-xpc-tooltip-opacity-seven`;
          break;
        case 0.5:
          classList += ` rt-xpc-tooltip-opacity-five`;
          break;
        case 0.3:
          classList += ` rt-xpc-tooltip-opacity-three`;
          break;
      }
      let size = this.size || xpcConfig.get('toolTip.size');
      if (size) {
        classList += ` rt-xpc-tooltip-size-${size}`;
      }
      if (this.popperClass) {
        classList += ` ${this.popperClass}`;
      }
      classList += ' rt-xpc-box-shadow-light';
      return classList;
    }
  },

  mounted () {
    this.$nextTick(() => {
      let maxWidth = this.maxWidth || xpcConfig.get('toolTip.maxWidth');
      if (maxWidth) {
        let tooltipRef = this.$refs.tooltip;
        if (tooltipRef && tooltipRef.$refs && tooltipRef.$refs.popper) {
          tooltipRef.$refs.popper.style.maxWidth = `${maxWidth}px`;
        }
      }
    });
  }
};
</script>



// WEBPACK FOOTER //
// rtTooltip.vue?74ff9b19